<mat-drawer-container hasBackdrop>
  <mat-drawer autoFocus="false" #drawer mode="over" position="end" (closed)="close()">
    <app-right-sidebar-container
      [title]="(isEditing ? 'Update' : 'Create') + ' Provider'"
      [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Create'"
      (cancel)="close()"
      (submit)="onSubmit()"
      [disableSubmit]="form.invalid || isLoading"
      >
      <form [formGroup]="form" class="provider-content">
        <div class="custom-form-field">
          <label for="email">Email address<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="email" matInput name="email" />
            @if (form.controls['email'].errors?.['required']) {
              <mat-error>
                Enter email address
              </mat-error>
            }
            @if (form.controls['email'].errors?.['email']) {
              <mat-error>
                Enter valid email address
              </mat-error>
            }
            @if (form.controls['email'].errors?.['entityExists']) {
              <mat-error>
                User already exists with this email
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="firstName">First Name<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="firstName" matInput name="firstName"/>
            @if (form.controls['firstName'].errors?.['required']) {
              <mat-error>
                Enter First Name
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="lastName">Last Name<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="lastName" matInput name="lastName"/>
            @if (form.controls['lastName'].errors?.['required']) {
              <mat-error>
                Enter Last Name
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="phoneNumber">Phone Number<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input 
              formControlName="phoneNumber" 
              matInput 
              name="phoneNumber"
              type="tel"
              maxlength="10"
              minlength="10"
              [appPhoneInput]="true"
            />
            @if (form.controls['phoneNumber'].errors?.['required']) {
              <mat-error>
                Enter Phone Number
              </mat-error>
            }
             @if (form.controls['phoneNumber'].errors?.['invalidPhone']) {
          <mat-error>Phone number must be exactly 10 digits</mat-error>
        }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="role">Access Level<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <mat-select formControlName="role" name="role">
              @for (option of roleOptions; track option.id) {
                <mat-option [value]="option.id">{{ option.name }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
            @if (form.controls['role'].errors?.['required']) {
              <mat-error>Please select Access Level</mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    </app-right-sidebar-container>
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        <h3 class="pcs-title">{{organization?.name || '-'}}</h3>
      </div>
      <br />

      <div class="card-body">
        <app-row-details-data [data]="descriptionRowData" ></app-row-details-data>

        <br />
        <div>
          <mat-tab-group #providerTabGroup class="provider-tabs" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
            @if (isLender() || isLenderReadOnly()) {
            @if (organization?.providerType === 2) {
            <mat-tab label="Forms Management">
              <ng-template matTabContent>
                <app-forms-inventory-panel
                  [organizationId]="this.organizationId"
                  [isLenderView]="true"
                ></app-forms-inventory-panel>
              </ng-template>
            </mat-tab>
            }
            <mat-tab label="Marketing Materials">
              <ng-template matTabContent>
                <app-marketing-material-inventory-panel
                  [organizationId]="this.organizationId"
                ></app-marketing-material-inventory-panel>
              </ng-template>
            </mat-tab>
            @for (documentType of documentTypes; track documentType) {
              <mat-tab [label]="documentType.name">
                <ng-template matTabContent>
                  <app-provider-documents
                    [organizationId]="this.organizationId"
                    [organizationName]="currentOrganizationName"
                    [childOrganizations]="childOrganizations"
                    [documentType]="documentType"
                    [states]="states"
                    [products]="products"
                    [industries]="industries"
                    [userRole]="userRole()"
                    >
                  </app-provider-documents>
                </ng-template>
              </mat-tab>
            }
            <mat-tab label="Approvals">
              <ng-template matTabContent>
                <app-provider-approval-panel
                  [organizationId]="this.organizationId">
                </app-provider-approval-panel>
              </ng-template>
            </mat-tab>
            <mat-tab label="Corporate Documents">
              <ng-template matTabContent>
                <app-corporate-document-panel
                  [organizationId]="this.organizationId">
                </app-corporate-document-panel>
              </ng-template>
            </mat-tab>
            <mat-tab label="Miscellaneous Documents">
              <ng-template matTabContent>
                <app-miscellaneous-document-panel
                  [organizationId]="this.organizationId">
                </app-miscellaneous-document-panel>
              </ng-template>
            </mat-tab>
            }
            @if (!isLender() && !isLenderReadOnly()){
            <mat-tab label="Users">
              <ng-template matTabContent>
                <div class="pcs-container">
                  <div class="pcs-header">
                    <h3 class="pcs-title">Users</h3>
                    @if (isAdmin()) {
                    <div class="card-actions">
                      <button (click)="openProviderSidebar()"
                        mat-flat-button
                        color="primary"
                        type="button"><mat-icon>add</mat-icon> Create</button>
                      </div>
                    }
                    </div>
                    <app-search-sort
                      [searchControl]="searchControl"
                      [sortForm]="sortForm"
                      [sortOptions]="sortOptions"
                      (apply)="setSortField()"
                      (close)="resetSortField()"
                    ></app-search-sort>
                    <div class="pro-card column">

                      <app-ag-grid-wrapper
                        [data]="rowData"
                        [columns]="columnDefs"
                        (ready)="onGridReady($event)"
                        />
                        <mat-paginator
                          #paginator
                          [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
                          [length]="this.totalCount"
                          [pageIndex]="this.currentPage"
                          [pageSize]="this.pageSize"
                          [pageSizeOptions]="pageSettings.pageSizeOptions"
                          (page)="handlePageEvent($event)"
                          aria-label="Select page"
                          >
                        </mat-paginator>
                      </div>
                    </div>
                  </ng-template>
                </mat-tab>
            <mat-tab label="Relationships">
              <ng-template matTabContent>
                <div class="relationships-wrapper">
                  <app-org-structure 
                    [organizationId]="organizationId" 
                    [organization]="organization"
                    [organizationService]="providerOrganizationService"
                    [isAdmin]="isAdmin()" 
                    [isSystemUser]="isSystemUser()"  
                    (relationshipsChanged)="onStructureChanged()">
                  </app-org-structure>

                  <app-org-associations
                    [organizationId]="organizationId"
                    [organizationService]="providerOrganizationService"
                    [isAdmin]="isAdmin()"
                    [isSystemUser]="isSystemUser()">
                  </app-org-associations>

                  <app-org-consultants
                    [organizationId]="organizationId">
                  </app-org-consultants>
                </div>
              </ng-template>
            </mat-tab>
            @if (organization?.providerType === 2) {
            <mat-tab label="Forms Management">
              <ng-template matTabContent>
                <app-forms-inventory-panel
                  [organizationId]="this.organizationId"
                  (onSubmit)="onSubmitFormInventory($event)"
                ></app-forms-inventory-panel>
              </ng-template>
            </mat-tab>
            }
            <mat-tab label="Marketing Materials">
              <ng-template matTabContent>
                <app-marketing-material-inventory-panel
                  [organizationId]="this.organizationId"
                ></app-marketing-material-inventory-panel>
              </ng-template>
            </mat-tab>

                @for (documentType of documentTypes; track documentType) {
                  <mat-tab [label]="documentType.name">
                    <ng-template matTabContent>
                      <app-provider-documents
                        [organizationId]="this.organizationId"
                        [organizationName]="currentOrganizationName"
                        [childOrganizations]="childOrganizations"
                        [documentType]="documentType"
                        [states]="states"
                        [products]="products"
                        [industries]="industries"
                        [userRole]="userRole()"
                        >
                      </app-provider-documents>
                    </ng-template>
                  </mat-tab>
                }

            <mat-tab label="Approvals">
              <ng-template matTabContent>
                <app-provider-approval-panel
                  [organizationId]="this.organizationId">
                </app-provider-approval-panel>
              </ng-template>
            </mat-tab>

            <mat-tab label="Corporate Documents">
              <ng-template matTabContent>
                <app-corporate-document-panel
                  [organizationId]="this.organizationId">
                </app-corporate-document-panel>
              </ng-template>
            </mat-tab>

            <mat-tab label="Miscellaneous Documents">
              <ng-template matTabContent>
                <app-miscellaneous-document-panel
                  [organizationId]="this.organizationId">
                </app-miscellaneous-document-panel>
              </ng-template>
            </mat-tab>

                @if (!isSystemUser() && !isLender()) {
                  <mat-tab label="Invoices">
                    <ng-template matTabContent>
                      @if (!isLoading) {
                        <app-provider-invoices
                          [organizationId]="this.organizationId"
                        ></app-provider-invoices>
                      }
                    </ng-template>
                  </mat-tab>
                }
              }
              </mat-tab-group>
            </div>
          </div>
        </div>
  </mat-drawer-content>
</mat-drawer-container>

